import { NgModule } from '@angular/core';
import { SanitizerPipe } from './sanitizer';
@NgModule({
	declarations: [SanitizerPipe],
	imports: [],
	exports: [SanitizerPipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts